enum PromptLibraryLink {
  BI = 'https://www.notion.so/newfront/21d63cbd78f8806c9d03c01472100829?v=21d63cbd78f880829db6000c11062491',
  TR = 'https://www.notion.so/newfront/21d63cbd78f8809bbeb2c62a5e0d3436?v=21d63cbd78f8802486bd000cc7b14182',
}

interface ChatDisclaimerProps {
  /** Apply Nova Addins (Outlook) specific styling */
  isNovaAddins?: boolean;
  /** Hide Newfront prompt library links for WTW colleague users */
  isWtwColleague?: boolean;
}

/**
 * Disclaimer component that displays Nova Assist disclaimer with prompt library links.
 */
export function ChatDisclaimer({ isNovaAddins = false, isWtwColleague = false }: ChatDisclaimerProps) {
  if (isWtwColleague) {
    return <span className="text-muted-foreground block py-3 text-center text-sm">Nova Assist can make mistakes.</span>;
  }

  return (
    <span className="text-muted-foreground block py-3 text-center text-sm">
      Nova Assist can make mistakes. Explore what
      {isNovaAddins && <br />} Nova can do: Browse prompt library for{' '}
      <a href={PromptLibraryLink.BI} target="_blank" rel="noreferrer" className="font-semibold underline">
        BI
      </a>{' '}
      and{' '}
      <a href={PromptLibraryLink.TR} target="_blank" rel="noreferrer" className="font-semibold underline">
        TR
      </a>
    </span>
  );
}
